var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.likeType === 'topic'
        ? 'f-icon-topic-evaluate' : 'f-icon-reply-evaluate',on:{"click":_vm.evaluate}},[_c('img',{class:_vm.likeType === 'topic'
            ? 'f-icon-topic-evaluate-img' : 'f-icon-reply-evaluate-img',attrs:{"src":_vm.icon}}),_c('span',{staticClass:"f-icon-topic-evaluate-word"},[_vm._v(_vm._s(_vm.likeCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }